import React, { useState, useEffect } from 'react';
import { useAudio } from '../../contexts/AudioContext';
import { Info, Globe, MapPin, ExternalLink } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function StationInfo() {
  const { stationData, stationConfig } = useAudio();
  const station = stationData?.station;
  const [config, setConfig] = useState(null);

  useEffect(() => {
    // Fetch station config for about text
    const fetchConfig = async () => {
      try {
        const response = await fetch(`${API_URL}/api/station/config`);
        if (response.ok) {
          const data = await response.json();
          setConfig(data);
        }
      } catch (err) {
        console.log('Failed to fetch config');
      }
    };
    fetchConfig();
  }, []);

  const aboutText = config?.about_text || stationConfig?.about_text || station?.description || "Nashville's #1 Internet Radio Station With The Hottest Blends";

  return (
    <div 
      className="glass rounded-2xl p-4"
      data-testid="station-info-panel"
    >
      <div className="flex items-center gap-2 mb-4">
        <Info className="w-5 h-5" style={{ color: 'var(--primary)' }} />
        <h3 
          className="text-lg font-bold"
          style={{ fontFamily: 'Teko, sans-serif', color: 'var(--text-main)' }}
        >
          About
        </h3>
      </div>

      <div className="space-y-3">
        <p className="text-sm whitespace-pre-line" style={{ color: 'var(--text-muted)' }}>
          {aboutText}
        </p>
        
        <div className="flex items-center gap-2 text-sm" style={{ color: 'var(--text-muted)' }}>
          <MapPin className="w-4 h-4" />
          <span>Nashville, TN (CST)</span>
        </div>

        <div className="flex gap-2 pt-2">
          <a
            href={station?.url || "https://snapdismedia.stream/public/wnuv_the_nu_vibe"}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 flex items-center justify-center gap-2 p-2 rounded-lg transition-all hover:scale-105"
            style={{ backgroundColor: 'var(--surface-highlight)' }}
            data-testid="station-website"
          >
            <Globe className="w-4 h-4" style={{ color: 'var(--primary)' }} />
            <span className="text-xs" style={{ color: 'var(--text-main)' }}>Website</span>
          </a>
          
          <a
            href={station?.public_player_url || "https://snapdismedia.stream/public/wnuv"}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 flex items-center justify-center gap-2 p-2 rounded-lg transition-all hover:scale-105"
            style={{ backgroundColor: 'var(--surface-highlight)' }}
            data-testid="station-player"
          >
            <ExternalLink className="w-4 h-4" style={{ color: 'var(--secondary)' }} />
            <span className="text-xs" style={{ color: 'var(--text-main)' }}>Full Site</span>
          </a>
        </div>
      </div>
    </div>
  );
}
